import React, { useState } from 'react';
import moment from 'moment';
import useOnMount from '../../../hooks/useOnMount';

const HourHand = () => {
	const now = moment();
	const [rotation, setRotation] = useState(0);

	useOnMount(() => {
		let hours = now.hours();
		const minutes = now.minutes();
		if(hours >= 12) hours -= 12;
		hours += minutes / 60;
		const hoursAsDeg = (hours / 12) * 360;
		setRotation(hoursAsDeg);
	});

	return (
		<polygon
			id="HourHand"
			fill="#AFB9C5"
			points="53 25 55 52 51 52"
			style={{
				transform: `rotate(${rotation}deg)`,
				transformOrigin: '3.3% 7.9%',
				transition: 'transform 1200ms ease'
			}}>
		</polygon>
	);
};

export default HourHand;
